/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
import { FaInfoCircle } from 'react-icons/fa';
import { RiErrorWarningFill } from "react-icons/ri";
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState, useEffect } from 'react';
import {
  strToBool,
} from '../../../../helpers/helpers';
import Select from '../../../../components/select';
import { getMyWriters } from '../../../../api/queries';
import ButtonPrimary from '../../../../components/buttonPrimary';
import ButtonPrimaryText from '../../../../components/buttonPrimaryText';
import AppState from '../../../../store/appstate';
import RebrandButtonLink from '../../../../components/rebrandButtonLink';
import useSiteConfigAuth from '../../../../api/sanity/queries/getSiteConfigWithCode';
import RebrandPrimaryButton from '../../../../components/rebrandPrimaryButton';
import Spacer from '../../../../components/spacer';
import SongWriterSplitCreateRow from './SongWriterSplitCreateRow';
import getColours from '../../../../helpers/getColours';
// import WritersForm from '../writers/writersForm';
import P from '../../../../components/p';
// import SubModal from '../../../../components/SubModal';

function SongWriterSplitCreate({ onWorkSplitFieldUpdate, onWriterModalOpen, errors, existingSplits, updateWorkEtag }) {
  const [splits, setSplits] = useState([]);
  const [selectedWriter, setSelectedWriter] = useState(null);
  const { t } = useTranslation('songs');
  const flags = useFlags();
  const reskinFlag = flags['publishing-dashboard-reskin'];
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const writers = getMyWriters({ aac: selectedAccount });
  const { data: siteConfig } = useSiteConfigAuth();
  const { highlightColour2 } = getColours();
  const isTunecore = siteConfig?.display_name === 'TuneCore';

  useEffect(() => {
    setSplits(existingSplits);
  }, [existingSplits]);

  const handleDeleteSongWriter = (writercode) => {
    let splitArray = splits.slice();
    splitArray = splitArray.filter((s) => s.writercode !== writercode);
    onWorkSplitFieldUpdate(splitArray);
  };

  const handlesetWriterSplitField = ({ writercode, field, x }) => {
    const splitArray = splits.slice();
    const item = splitArray.find((w) => w.writercode === writercode);
    if (field === 'righttocollect') {
      item.righttocollect = strToBool(item.righttocollect) ? 'false' : 'true';
    } else {
      item[field] = x;
    }
    onWorkSplitFieldUpdate(splitArray);
  };

  const shareSplitsEqually = () => {
    const numberWriters = splits.length;
    const writerArray = splits.slice();
    if (numberWriters > 0) {
      const share = (100 / numberWriters).toFixed(2);
      writerArray.forEach((s, i) => {
        s.writershare = share;
        // set last writer slightly higher incase odd number
        if (i === (numberWriters - 1)) {
          s.writershare = (100 - i * share).toFixed(2);
        }
      });
      onWorkSplitFieldUpdate(writerArray);
    }
  };

  let writerSplitsPercentage = 0;
  splits?.forEach((s) => {
    if (s.writershare && !s.isdeleted) {
      writerSplitsPercentage += Number(s.writershare);
    }
  });
  writerSplitsPercentage = writerSplitsPercentage.toFixed(2);

  return (
    <>
      <div className="w-full">
        <h2 className="text-xl">
          {t('songs:writers')}
          {' '}
          &amp;
          {' '}
          {t('songs:splits')}
        </h2>
        <Spacer thin />

        <div style={{ backgroundColor: reskinFlag && isTunecore ? '#222222' : reskinFlag ? highlightColour2 : '#4eb4ba' }} className={`${reskinFlag && isTunecore ? 'px-14 py-9 text-white h-auto md:h-28 flex-wrap md:flex-nowrap' : reskinFlag ? 'px-14 py-9 text-black h-auto md:h-28 flex-wrap md:flex-nowrap' : 'p-4 text-white flex-wrap'} rounded-t-lg flex gap-5 md:gap-0`}>
          <div className={`${reskinFlag ? 'flex flex-col justify-evenly ' : ''}  md:w-1/2 w-full`}>
            <div>
              <p className="text-lg">
                {t('songs:writer-splits-assigned')}
                :
                <span className="ml-2 font-semibold">
                  {writerSplitsPercentage}
                  %
                </span>
              </p>
            </div>
            <div className="relative w-full pt-1">
              <div className="flex h-2 overflow-hidden text-xs rounded bg-old-sentric-menu-gray">
                <div style={{ width: `${writerSplitsPercentage}%` }} className={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center ${reskinFlag && isTunecore ? 'bg-tunecore-green' : 'bg-old-sentric-submenu-icon'}`} />
              </div>
            </div>
          </div>
          <div className="flex justify-center w-full md:w-1/2 md:justify-end lg:mb-0">
            {reskinFlag ? (
              <RebrandPrimaryButton
                onClick={() => shareSplitsEqually()}
                id="btnSongFormShareWriterSplit"
                underlined={!isTunecore}
              >
                {t('songs:share-splits-equally')}
              </RebrandPrimaryButton>
            ) : (
              <ButtonPrimary id="btnSongFormShareWriterSplit" onClick={() => shareSplitsEqually()} invert>{t('songs:share-splits-equally')}</ButtonPrimary>
            )}
          </div>
        </div>
        <div className={`${isTunecore ? '' : 'bg-white'} rounded-lg`}>
          <div className={`uppercase ${reskinFlag && isTunecore ? 'bg-tunecore-mid-grey text-white underline' : reskinFlag ? 'bg-black text-white text-sm underline' : 'font-semibold text-xxs bg-old-sentric-table-border text-old-song-sub-color'} px-6 py-4 hidden lg:flex`}>
            <div id="colWriterSplitName" className="w-2/12">
              <p>{t('songs:writer-table-name')}</p>
            </div>
            <div id="colWriterSplitMembership" className="w-2/12">
              <p>{t('songs:writer-table-membership')}</p>
            </div>
            <div id="colWriterSplitRole" className="w-2/12">
              <p>{t('songs:writer-table-role')}</p>
            </div>
            <div id="colWriterSplitSplit" className="w-3/12">
              <p>{t('songs:writer-table-split')}</p>
            </div>
          </div>
          {splits && splits.map((w, i) => (
            <SongWriterSplitCreateRow
              key={w.writercode}
              writer={w}
              deleteSongWriter={handleDeleteSongWriter}
              i={i}
              last={i === (splits.length - 1)}
              setWriterSplitField={handlesetWriterSplitField}
              updateWorkEtag={updateWorkEtag}
            />
          ))}

          <div className={`p-6 ${isTunecore && reskinFlag ? 'bg-tunecore-mid-grey' : ''}`}>
            {reskinFlag ? (
              <div className="flex flex-wrap items-center w-full">
                <div className="w-full mb-2 lg:w-4/12 lg:mb-0">
                  {writers.isSuccess
                    && (
                      <>
                      <Select
                          showLabel={false}
                          id="btnSongFormSelectWriter"
                          options={writers?.data?.writers.filter((w) => !splits.filter((sw) => !sw.isdeleted).map((s) => s.writercode).includes(w.writercode)).map((w) => ({ name: `${w.firstname} ${(!w.middlename || w.middlename === 'null') ? '' : w.middlename} ${w.lastname} ${(!w.caeipinumber || w.caeipinumber === 'null' ? '' : w.caeipinumber)}`, value: w.writercode }))}
                          onChange={(selected) => setSelectedWriter(selected)}
                          value={selectedWriter}
                          className={`select-search  ${isTunecore && reskinFlag ? 'tunecore-select'
                              : reskinFlag
                                ? 'font-sentric-alt text-base select-grey-bg'
                                : ''
                            }  text-black font-semibold`}
                          search
                          filterOptions
                          placeholder={t('songs:select-writer-placeholder')}
                        />
                      </>
                    )}
                </div>
                <div className="w-full mb-2 lg:w-4 lg:mb-0" />
                <RebrandButtonLink
                  plusIcon
                  smallfont
                  id="btnSongFormAddWriter"
                  onClick={() => {
                    if (selectedWriter) {
                      setSplits([...splits, { writercode: selectedWriter, righttocollect: 'false' }]);
                      setSelectedWriter(null);
                    }
                  }}
                >
                  {t('songs:add-writer-button')}
                </RebrandButtonLink>
                <div className="w-full mb-2 lg:w-4 lg:mb-0" />
                <div className="flex items-center justify-end flex-1 mt-4 text-xs md:mt-0">
                  <p className="mr-2">{t('songs:writer-not-listed')}</p>
                  <RebrandButtonLink
                    smallfont
                    plusIcon
                    id="btnSongFormCreateWriter"
                    onClick={() => onWriterModalOpen(true)}
                  >
                    {t('songs:create-new-writer')}
                  </RebrandButtonLink>
                </div>
              </div>
            ) : (
              <div className="flex flex-wrap items-center w-full">
                <div className="w-full mb-2 lg:w-5/12 lg:mb-0">
                  {writers.isSuccess
                    && (
                      <Select
                        id="btnSongFormSelectWriter"
                        className="w-full text-old-sentric-dark-gray select-grey-bg"
                        name="writer"
                        value={selectedWriter}
                        placeholder={t('songs:select-writer-placeholder')}
                        onChange={(selected) => setSelectedWriter(selected)}
                        options={writers?.data?.writers.filter((w) => !splits.filter((sw) => !sw.isdeleted).map((s) => s.writercode).includes(w.writercode)).map((w) => ({ name: `${w.firstname} ${(!w.middlename || w.middlename === 'null') ? '' : w.middlename} ${w.lastname} ${(!w.caeipinumber || w.caeipinumber === 'null' ? '' : w.caeipinumber)}`, value: w.writercode }))}
                        search
                      />
                    )}
                </div>
                <div className="w-full mb-2 lg:w-4 lg:mb-0" />
                <ButtonPrimary
                  id="btnSongFormAddWriter"
                  onClick={() => {
                    if (selectedWriter) {
                      setSplits([...splits, { writercode: selectedWriter, righttocollect: 'false' }]);
                      setSelectedWriter(null);
                    }
                  }}
                >
                  {t('songs:add-writer-button')}
                </ButtonPrimary>
                <div className="w-full mb-2 lg:w-4 lg:mb-0" />
                <div className="flex items-center justify-end flex-1 text-xs">
                  <p className="mr-2">{t('songs:writer-not-listed')}</p>
                  <ButtonPrimaryText id="btnSongFormCreateWriter" onClick={() => onWriterModalOpen(true)}>
                    {t('songs:create-new-writer')}
                  </ButtonPrimaryText>
                </div>
              </div>
            )}
          </div>
        </div>
        <Spacer thin />
        {!!errors.writers
          && <p className={`w-4/5 ${isTunecore && reskinFlag ? 'bg-tunecore-error-red bg-opacity-20 border-none' : reskinFlag ? 'font-sentric-alt bg-red-700 border-white border' : 'bg-red-700 border-white border'} text-sm inline-block p-1 pr-3 pl-3 mt-2 text-white rounded-lg mb-4 `}>
            {isTunecore && (
              <span>
                <RiErrorWarningFill className="inline-block mr-2 text-2xl text-tunecore-error-red" />
              </span>
            )}
            {errors.writers}
          </p>}
        <P small>
          <FaInfoCircle className="inline mr-2" />
          {' '}
          {t('songs:when-adding-writers-percentage')}
        </P>
      </div>

    </>
  );
}

export default SongWriterSplitCreate;